var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrowBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H5ZM12.75 6V16.2403L16.4806 12.659C16.7794 12.3721 17.2542 12.3818 17.541 12.6806C17.8279 12.9794 17.8182 13.4542 17.5194 13.741L12.5194 18.541C12.2292 18.8197 11.7708 18.8197 11.4806 18.541L6.4806 13.741C6.18179 13.4542 6.1721 12.9794 6.45896 12.6806C6.74582 12.3818 7.22059 12.3721 7.5194 12.659L11.25 16.2403V6C11.25 5.58579 11.5858 5.25 12 5.25C12.4142 5.25 12.75 5.58579 12.75 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrowBox);
export default __webpack_public_path__ + "static/media/down-arrow-box.732cd09edc9b353f3321f2c5cd21716e.svg";
export { ForwardRef as ReactComponent };